import React from 'react';
import type { BoletoPaymentViewProps } from './types/boleto-payment.types';
import { useBoletoPayment } from './hooks/useBoletoPayment';
import BoletoHeader from './components/BoletoHeader';
import BoletoDetails from './components/BoletoDetails';
import BoletoActions from './components/BoletoActions';
import BoletoInstructions from './components/BoletoInstructions';

const BoletoPaymentView: React.FC<BoletoPaymentViewProps> = (props) => {
  const { codeCopied, handleCopyCode } = useBoletoPayment(props);

  const handleContinueToStore = () => {
    // Redirecionar diretamente para a homepage da loja
    // Tenta homePage primeiro, depois corsUrl como fallback
    if (props.shopifyData?.store?.homePage) {
      window.location.href = props.shopifyData.store.homePage;
    } else if (props.shopifyData?.store?.corsUrl) {
      window.location.href = props.shopifyData.store.corsUrl;
    } else {
      console.warn('Homepage ou corsUrl da loja não encontrados');
    }
  };

  return (
    <div className="container mx-auto p-4 sm:p-6 lg:p-8 max-w-3xl bg-card-bg-light dark:bg-card-bg-dark shadow-xl rounded-lg my-8">
      <BoletoHeader 
        customerName={props.customerName}
        totalAmount={props.totalAmount}
      />

      <BoletoDetails
        paymentDetails={props.paymentDetails}
        onCopyCode={handleCopyCode}
        codeCopied={codeCopied}
        fullData={props.fullData}
      />
      
      <BoletoActions pdfUrl={props.paymentDetails.pdf} />

      <BoletoInstructions />

      <div className="mt-8 text-center text-sm text-text-secondary dark:text-gray-400">
        <p>Em caso de dúvidas, entre em contato com nosso suporte.</p>
      </div>

      {/* Botão para continuar à loja */}
      <div className="mt-6 text-center">
        <div className="mb-3 text-lg text-text-secondary dark:text-gray-400">
          Continuar para a loja após finalizar o pagamento
        </div>
        <button
          onClick={handleContinueToStore}
          className="text-white font-semibold py-3 px-6 rounded-lg transition duration-150 text-base btn-primary"
        >
          Continuar à Loja
        </button>
      </div>
    </div>
  );
};

export default BoletoPaymentView; 